module.exports = __webpack_public_path__ + "media/images/design/common/images/btn_desearch_open-f291bbde38d6ac22ea9739978d1dcf8d.gif";